const SEEN_KEY = 'basket:rotationalOverlaySeen';
const REMIND_KEY = 'basket:rotationalOverlayRemind';
const DISMISSED_KEY = 'basket:rotationalOverlayDismissed';
const LEGACY_OPT_OUT_KEY = 'basket:placementCelebrationOptedOut';

const buildKey = (prefix, userId) => `${prefix}:${userId || 'anonymous'}`;

const readFlag = (prefix, userId) => {
  if (typeof window === 'undefined') return false;
  try {
    return localStorage.getItem(buildKey(prefix, userId)) === 'true';
  } catch {
    return false;
  }
};

const writeFlag = (prefix, userId, value) => {
  if (typeof window === 'undefined') return;
  try {
    localStorage.setItem(buildKey(prefix, userId), value ? 'true' : 'false');
  } catch {
    /* ignore quota errors */
  }
};

const hasRotationalOverlaySeen = (userId) => {
  if (readFlag(SEEN_KEY, userId)) return true;
  return readFlag(LEGACY_OPT_OUT_KEY, userId);
};

const hasRotationalOverlayRemind = (userId) => readFlag(REMIND_KEY, userId);

const hasRotationalOverlayDismissed = (userId) => readFlag(DISMISSED_KEY, userId);

/** Show overlay when not permanently dismissed and (remind pending or first time). */
export const shouldShowRotationalOverlay = (userId) => {
  if (hasRotationalOverlaySeen(userId)) return false;
  if (hasRotationalOverlayRemind(userId)) return true;
  return !hasRotationalOverlayDismissed(userId);
};

/** Consume one-time remind flag when the overlay is shown. */
export const consumeRemindFlagIfSet = (userId) => {
  if (hasRotationalOverlayRemind(userId)) {
    writeFlag(REMIND_KEY, userId, false);
  }
};

export const applyPlacementCelebrationContinue = (userId) => {
  writeFlag(SEEN_KEY, userId, true);
  writeFlag(LEGACY_OPT_OUT_KEY, userId, true);
};

export const applyPlacementCelebrationRemind = (userId) => {
  writeFlag(REMIND_KEY, userId, true);
  writeFlag(DISMISSED_KEY, userId, true);
};
